import React from "react";

const TermsOfService = () => (
  <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-md my-10">
    <h1 className="text-3xl font-bold mb-4 text-center">
      Terms of Service for Roots
    </h1>
    <p className="text-sm text-gray-500 mb-8 text-center">
      Effective Date: 11/5/2025
    </p>

    <section className="space-y-6">
      <p>
        These Terms of Service ("Terms") govern the services ("Services")
        provided to you by Roots Fulfillment Center ("Roots", "we", "us", or
        "our"). By accessing or using our Services, you agree to be bound by
        these Terms and our Privacy Policy. If you do not agree to these Terms,
        please do not use our Services.
      </p>

      <div>
        <h2 className="text-xl font-semibold mb-2">1. Scope of Services</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>Storing products in Roots warehouses</li>
          <li>Delivery of products to end-customers</li>
          <li>Customer support and scheduling</li>
          <li>Handling of return and exchange orders</li>
          <li>Packing, packaging, and personalizing shipments</li>
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          2. Modifications to Terms
        </h2>
        <p>
          We may amend these Terms by giving you at least seven (7) days’
          written notice. Continued use of the Services after the notice period
          constitutes acceptance of the revised Terms.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">3. Fees</h2>
        <p>
          Fees for our Services are outlined in the service agreement or as
          otherwise communicated. We reserve the right to modify our fees with
          at least fifteen (15) days notice to you.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">4. Payments</h2>
        <p>
          <strong>General:</strong> All payments must be made in JOD via
          approved methods. Each party bears its own bank fees.
        </p>
        <p>
          <strong>Upfront Payments:</strong> Storage is billed in advance,
          including prorated charges for mid-month additions.
        </p>
        <p>
          <strong>Monthly Billing Cycle:</strong> End-of-month invoice includes
          order handling, storage, COD, and packaging fees.
        </p>
        <p>
          <strong>Weekly COD Settlement:</strong> Weekly summaries determine net
          payout or payin.
        </p>
        <p>
          <strong>Late Payments:</strong> Interest of 4% per annum may be
          charged on overdue invoices.
        </p>
        <p>
          <strong>Invoice Disputes:</strong> Must be raised within seven (7)
          days.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">5. Bookings and Delivery</h2>
        <p>
          Orders must be submitted via the Roots Merchant Portal or
          email/WhatsApp and confirmed before 3:00 PM for next-day processing.
          Delivery timelines are not guaranteed for delays beyond our control.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">6. Items for Delivery</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>No illegal, hazardous, or improperly packaged items.</li>
          <li>Roots may reject non-compliant items.</li>
          <li>Customer is responsible for packaging.</li>
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">7. Intellectual Property</h2>
        <p>
          All rights remain with Roots or its licensors. You receive a limited
          license for service usage only.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">8. Warranties</h2>
        <p>
          You agree to comply with laws and terms. Services are provided "as is"
          with no warranties.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">9. Force Majeure</h2>
        <p>
          Neither party is liable for delays caused by events outside of
          reasonable control.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">10. Confidentiality</h2>
        <p>
          Both parties must maintain confidentiality unless disclosure is
          legally required.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">11. Liability</h2>
        <p>
          Roots does not insure goods. We are not liable for indirect damages
          unless due to gross negligence.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">12. Termination</h2>
        <p>
          Either party may terminate with 30 days' notice. Breaches may result
          in immediate termination. Outstanding payments become due upon
          termination.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">
          13. Technical Limitations
        </h2>
        <p>
          Roots is not responsible for internet-related issues or electronic
          failures.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">14. Contact Us</h2>
        <p>
          Email:{" "}
          <a
            href="mailto:admin@roots-jo.co"
            className="text-blue-600 underline"
          >
            admin@roots-jo.co
          </a>
        </p>
        <p>Address: Khalda, Amman, Jordan</p>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-2">15. General Provisions</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>Entire agreement between you and Roots</li>
          <li>If any clause is invalid, others remain in effect</li>
          <li>Governed by Jordanian law and courts of Amman</li>
          <li>We may suspend services for non-payment or abuse</li>
        </ul>
      </div>
    </section>
  </div>
);

export default TermsOfService;
